import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitDate'
})
export class SplitDatePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    return value.replace(/-/g, '.').split(' ')[0];
  }
}
